module.exports = __webpack_public_path__ + "32f65eef12672bb96824af271424fa3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/modelo2.png
// module id = 2813
// module chunks = 1